<mat-card class="mcd-card">
  <mat-card-header
    class="mcd-card-header"
    style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    "
  >
    <mat-card-title class="mcd-card-title"
      >Obsolete Equipment </mat-card-title
    >
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-location-type-filter
          [standardFiltration]="standardFiltrationForChipSet"
          [standardListType]="standardListType.Obsolete"
          (messageEvent)="receivedFilteration($event)"
          (searchApplied)="onSearchFromChild($event)"
          [searchKeyFromParent]="searchKey"
          [allCountries]="countries"
          (countrySelected)="onCountryfromChild($event)"
          (exportListFilter)="handleExport($event)"
          (countryListFilter)="handleCountryList($event)"
        ></app-location-type-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="row">
        <div *ngIf="standards.length > 0" class="col-md-12">
          <!-- <div class="row">
            <div class="col-6">
              <mat-form-field>
                <mat-select
                  [value]="pageSize"
                  name="nOfRows"
                  #items
                  (selectionChange)="selectedItemsPerPageChange(items)"
                >
                  <mat-option
                    [value]="item.value"
                    *ngFor="let item of pageSizes"
                  >
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-6 float-right">
              <a
                class="float-right"
                href="javascript:void(0);"
                (click)="downloadExcel()"
                style="color: #0b59ca; text-decoration: none; cursor: pointer"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-bottom: 2px; margin-right: 2px"
                >
                  <path
                    d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Download All
              </a>
            </div>
          </div> -->
          <table
            class="table nrbes-grid"
            matSort
            (matSortChange)="sortData($event)"
          >
            <thead class="thead-light">
              <tr>
                <th width="24%" scope="col" mat-sort-header="title">
                  <div class="title-cell-wrapper">
                    <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0"
                      color="primary"
                      [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                      (click)="$event.stopPropagation()"
                      (change)="selectAllOnPageChange($event)"></mat-checkbox>
                    <span>Equipment Name</span>
                  </div>
                </th>
                <th width="16%" scope="col-2" mat-sort-header="equipment">
                  Type
                </th>
                <th scope="col" mat-sort-header="model" width="14%">Model</th>

                <th scope="col-4" width="18%">Location</th>
                <th scope="col-4" width="11%">Approved Date</th>
                <th scope="col-4" width="11%">Obsolete Date</th>
                <th
                  scope="col"
                  width="6%"
                  *ngIf="isGlobalAdmin()"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of standards" (click)="rowSelected(item)">
                <td
                  class="title-cell"
                  style="font-weight: 500; color: #3949a3; font-size: 14px; padding: 12px;"
                >
                  <div class="title-cell-wrapper">
                    <mat-checkbox
                      color="primary"
                      [checked]="isSelected(item.id)"
                      (click)="$event.stopPropagation()"
                      (change)="onCheckboxChange($event, item)"></mat-checkbox>
                    <span class="standard-title-text">{{ item.title }}</span>
                  </div>
                </td>
                <td class="category-cell">
                  {{ item.equipmentStandard?.equipmentType?.name || item.standard?.equipmentStandard?.equipmentType?.name }}
                </td>
                <td class="location-cell">
                  {{ item.equipmentStandard?.model || item.standard?.equipmentStandard?.model }}
                </td>

                <td class="category-cell">{{ getLocationNames(item) }}</td>
                <td class="category-cell">
                
                  {{ (item.effectiveFrom || item.standard?.effectiveFrom) | date: "MM.dd.yyyy" }}
                </td>
                <td class="category-cell">
                  
                  {{ (item.equipmentStandard?.obsoleteDate || item.standard?.equipmentStandard?.obsoleteDate) | date: "MM.dd.yyyy" }}
                </td>

                <td *ngIf="isGlobalAdmin()">
                  <div class="grid-actions hide-sm" *ngIf="selectedStandardsForExport.size < 2">
                    <button
                      style="border: none; background: none;"
                      (click)="togglePopup($event, item)"
                    >
                      <img src="/assets/images/menu-dots 2.svg" style="text-align: center;"/>
                    </button>

                    <div
                      class="action-popup editDeletModal"
                      *ngIf="activePopupId === item.id"
                    >
                      <!-- Edit Option -->
                      <div
                        style="padding: 8px; text-align: left; cursor: pointer;"
                        class="onEditHover"
                        (click)="onEdit(item.id, $event)"
                      >
                        <a
                          class="action-controls"
                          style="
                            text-decoration: none;
                            color: rgba(63, 81, 181, 1);
                            font-size: 14px;
                            text-align: left;
                            display: block;
                            width: 100%;
                          "
                          routerLinkActive="active"
                          title="Edit"
                          href="javascript:void(0);"
                        >
                          <span
                            ><img
                              src="/assets/images/d-edit 1.svg"
                              style="margin-bottom: 4px; margin-right: 5px"
                          /></span>
                          <span>Edit</span>
                        </a>
                      </div>

                      <hr style="margin: 2px; border: 1px solid #dde1e6" />

                      <!-- Delete Option -->
                      <div
                        style="padding: 8px; text-align: left; cursor: pointer;"
                        class="oDeleteHover"
                        (click)="openDeletePopup(item, $event)"
                      >
                        <a
                          class="action-controls"
                          style="
                            text-decoration: none;
                            color: rgba(222, 52, 40, 1);
                            font-size: 14px;
                            display: block;
                            width: 100%;
                          "
                          routerLinkActive="active"
                          title="clear"
                        >
                          <span
                            ><img
                              src="/assets/images/bin.svg"
                              style="margin-bottom: 4px; margin-right: 5px"
                          /></span>
                          <span>Delete</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td *ngIf="canEditEquipmentStandard">
                  <div class="row grid-actions hide-sm">
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="openDeletePopup(item, $event)"
                        routerLinkActive="active"
                        title="clear"
                        ><i class="material-icons"> clear </i></a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="onEdit(item.id)"
                        routerLinkActive="active"
                        title="Edit"
                        href="javascript:void(0);"
                        ><i class="material-icons"> create </i></a
                      >
                    </div>
                  </div>

                  <a
                    (click)="actionMenuOpen($event)"
                    class="mcd-more-btn show-sm"
                    [matMenuTriggerFor]="menu"
                    href="javascript:void(0);"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>
                  <mat-menu #menu="matMenu" overlapTrigger="false">
                    <span>
                      <button mat-menu-item (click)="onEdit(item.id)">
                        Edit
                      </button>
                      <button
                        mat-menu-item
                        (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                      >
                        Remove
                      </button>
                    </span>
                  </mat-menu>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        *ngIf="standards.length > 0"
      >
        <div >
          <div >
            <mat-form-field>
              <mat-select
                style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background-color: #f8fafb;
                  color: #4d5258;
                  font-weight: 500;
                "
                [value]="pageSize"
                name="nOfRows"
                #items
                (selectionChange)="selectedItemsPerPageChange(items)"
              >
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div >
          <div>
            <ngb-pagination
              class="float-right"
              [(page)]="page"
              [pageSize]="pageSize"
              [maxSize]="4"
              [rotate]="true"
              [ellipses]="true"
              [collectionSize]="collectionSize"
              (pageChange)="getAllEquipmentStandards()"
            ></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button
            class="prevButton"
            [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }"
            (click)="goToPreviousPage()"
          >
            <img src="/assets/images/leftarrow.svg" />

            Previous
          </button>
          <button
            class="nextButton"
            [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }"
            (click)="goToNextPage()"
          >
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>

      <!-- <div class="row" *ngIf="standards.length > 0">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getAllEquipmentStandards()"
          >
          </ngb-pagination>
        </div>
      </div> -->
      <div class="row">
        <div *ngIf="standards.length == 0 && !searchKey " class="noResults">
          Sorry you do not have any obsolete standard.
        </div>
      </div>

      

      <div *ngIf="standards.length == 0 && searchKey" class="search-empty-state">
        <img
          src="/assets/images/GRBES-List.svg"
          alt=""
          class="search-empty-icon"
        />
        <h4 class="search-empty-title">No results found</h4>
        <p class="search-empty-subtitle">
          Try a different keyword or refine your search to find what you're
          looking for.
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader *ngIf="loading"></app-mcd-loader>
